import React, { useRef } from 'react'
import { IconButton } from '../../../ui'

const SESSION_COLOR = '#9b6cc4'

export function FeedbackEntryList({ items = [], onChange, maxItems = 10, maxChars = 200, readOnly = false, isManagerView = false }) {
  const inputRefs = useRef([])

  function update(index, patch) {
    const next = items.map((item, i) => (i === index ? { ...item, ...patch } : item))
    onChange({ items: next })
  }

  function handleAdd() {
    if (items.length >= maxItems) return
    onChange({ items: [...items, { direction: 'm-to-r', text: '' }] })
    setTimeout(() => inputRefs.current[items.length]?.focus(), 0)
  }

  function handleRemove(index) {
    onChange({ items: items.filter((_, i) => i !== index) })
  }

  function toggleDirection(index) {
    const current = items[index].direction
    update(index, { direction: current === 'm-to-r' ? 'r-to-m' : 'm-to-r' })
  }

  return (
    <div style={styles.wrap}>
      {items.map((item, index) => (
        <div key={index} style={styles.entry}>
          <button
            style={{
              ...styles.directionBadge,
              ...(item.direction === 'm-to-r' ? styles.dirActive : styles.dirInactive),
            }}
            onClick={() => !readOnly && toggleDirection(index)}
            disabled={readOnly}
            aria-label={`Direction: ${item.direction === 'm-to-r' ? 'Manager to Report' : 'Report to Manager'}`}
          >
            {item.direction === 'm-to-r'
              ? (isManagerView ? 'me→' : '→me')
              : (isManagerView ? '→me' : 'me→')}
          </button>
          <input
            ref={(el) => { inputRefs.current[index] = el }}
            style={styles.input}
            value={item.text}
            maxLength={maxChars}
            disabled={readOnly}
            placeholder={readOnly ? '' : 'Feedback note…'}
            onChange={(e) => update(index, { text: e.target.value })}
            aria-label={`Feedback ${index + 1}`}
          />
          {!readOnly && (
            <IconButton ariaLabel="Remove feedback" onClick={() => handleRemove(index)} tabIndex={-1}>×</IconButton>
          )}
        </div>
      ))}
      {!readOnly && items.length < maxItems && (
        <button style={styles.addBtn} onClick={handleAdd}>+ add feedback</button>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 12px 12px', display: 'flex', flexDirection: 'column', gap: '6px' },
  entry: {
    background: 'var(--color-background-secondary, #f8f8f6)',
    borderRadius: '5px',
    padding: '6px 8px',
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
  },
  directionBadge: {
    fontSize: '9px', fontWeight: 700, padding: '2px 6px', borderRadius: '4px',
    border: 'none', cursor: 'pointer', flexShrink: 0, lineHeight: 1.4,
  },
  dirActive: { background: SESSION_COLOR, color: '#fff' },
  dirInactive: { background: '#f0ecf4', color: SESSION_COLOR, border: `1px solid ${SESSION_COLOR}44` },
  input: {
    flex: 1, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '11px', color: 'var(--text-primary)', lineHeight: '1.5', padding: '1px 0',
  },
  addBtn: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '11px',
    color: SESSION_COLOR, padding: '2px 0', textAlign: 'left', marginTop: '2px',
  },
}
